import {
  UPDATE_SETTINGS_ERROR,
  UPDATE_SETTINGS_SUCCESS,
  UPDATE_SETTINGS,
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_ERROR,
} from "./actionTypes";

const initialState = {
  settings: {},
  loadingSettings: false,
  loadingSettingsError: null,
  loadingSettingsSuccess: false,

  updateSettingsSuccess: false,
  updateSettingsError: null,
  updateSettingsLoading: false,
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case GET_SETTINGS:
      state = {
        ...state,
        loadingSettings: true,
        loadingSettingsError: null,
        loadingSettingsSuccess: false,
      };
      break;
    case GET_SETTINGS_SUCCESS:
      state = {
        ...state,
        settings: { ...state.settings, ...action.payload },
        loadingSettings: false,
        loadingSettingsSuccess: true,
        loadingSettingsError: null,
      };
      break;
    case GET_SETTINGS_ERROR:
      {
        state = {
          ...state,
          loadingSettings: false,
          loadingSettingsSuccess: false,
          loadingSettingsError: action.payload,
        };
      }
      break;
    case UPDATE_SETTINGS:
      state = {
        ...state,
        updateSettingsError: null,
        updateSettingsLoading: true,
        updateSettingsSuccess: false,
      };
      break;
    case UPDATE_SETTINGS_SUCCESS:
      state = {
        ...state,
        settings: { ...state.settings, ...action.payload },
        updateSettingsLoading: false,
        updateSettingsSuccess: true,
        updateSettingsError: null,
      };
      break;
    case UPDATE_SETTINGS_ERROR:
      state = {
        ...state,
        updateSettingsLoading: false,
        updateSettingsSuccess: false,
        updateSettingsError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default settings;
